import {
  call, put, takeEvery
} from 'redux-saga/effects';
import costImpactTermApi from '../../externals/costImpactTermsProxy';

import {
  FILE_IMPORT_ERROR,
  UNABLE_TO_LOAD_EI_TERM_DETAILS
} from '../../helpers/messageConstant';
import {
  receiveErrorInEarnedIncomeTermFileImport,
  receiveErrorInEiTermDetailsFetch,
} from '../actions/errorDialogActions';
import {
  REQUEST_OVERAGE_FILE_IMPORT,
  receiveOverageFileImport,
  receiveEiTermDetails,
  FETCH_EI_TERM_DETAILS,
} from '../actions/costImpactTermActions';

export function* fetchEiTermDetails({ data }) {
  try {
    const eiTermDetails = yield call(costImpactTermApi.fetchEiTermDetails, data);
    yield put(receiveEiTermDetails(eiTermDetails));
  } catch (e) {
    yield put(receiveErrorInEiTermDetailsFetch(UNABLE_TO_LOAD_EI_TERM_DETAILS));
  }
}

export function* importCostImpactEarnedIncomeTermFile({ data }) {
  try {
    yield call(costImpactTermApi.importCostImpactTermFile, data);
    yield put(receiveOverageFileImport('Successfully submitted the Earned Income Term file to process'));
  } catch (e) {
    yield put(receiveErrorInEarnedIncomeTermFileImport(FILE_IMPORT_ERROR));
  }
}

export function* costImpactTermsSaga() {
  yield takeEvery(REQUEST_OVERAGE_FILE_IMPORT, importCostImpactEarnedIncomeTermFile);
  yield takeEvery(FETCH_EI_TERM_DETAILS, fetchEiTermDetails);
}
